"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

// transform string date to moment date locale by default
// or in any other format given in format parameter (best practice : use moment locale format)
var formatDate = function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';

  if (date) {
    var formatedDate = (0, _moment.default)(date).format(format);
    return formatedDate;
  }

  return '-';
};

var _default = formatDate;
exports.default = _default;